import React from "react";

const ThemedInput = React.forwardRef((props, ref) => {
  const { primaryColor, themeMode, optional, ...inputProps } = props;

  return (
    <div>
      <label
        htmlFor={props.name}
        className="block text-sm/6 font-medium text-themed-primary"
      >
        {props.label}
        {optional && (
          <span className="ml-1 font-normal text-themed-secondary">(optional)</span>
        )}
      </label>
      <div className="mt-2">
        <input
          className={`themed-autofill block w-full rounded-md border-0 p-1.5 text-themed-primary bg-themed-card shadow-sm ring-1 ring-inset ${
            props.errormessage
              ? "ring-2 ring-signal-red-500"
              : "ring-themed-border focus-themed"
          } text-base sm:text-sm sm:leading-6 appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]`}
          ref={ref}
          disabled={props.disabled}
          {...inputProps}
        />
        {props.errormessage ? (
          <div className="mt-2 text-sm text-signal-red-500">
            <p>{props.errormessage}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
});

ThemedInput.displayName = "ThemedInput";

export default ThemedInput;